import React, { forwardRef } from 'react';
import { Box, IconButton } from '@mui/material';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import withDrag from '../../hoc/withDrag';  // Ensure the path is correct
import { useFormLayout } from '../../contexts/FormLayoutContext';  // Adjust the path as necessary

const DraggablePreviewWrapper = forwardRef(({ children, id, type, index, ...props }, ref) => {
    const { showDropZones, setShowDropZones } = useFormLayout(); // Fetching drop zone control from context

//    console.log(`[DraggablePreviewWrapper] Props received for ID: ${id}:`, { type, index, showDropZones, ...props });
//    console.log(`[DraggablePreviewWrapper] Using context-managed setShowDropZones for ID: ${id}`);

    return (
        <Box
            ref={ref}
            sx={{
                display: 'flex',
                alignItems: 'center',
                padding: 0,
                marginBottom: 0,
                borderRadius: '4px',
                backgroundColor: '#F4F6F8',
                cursor: 'grab',
                height: '36px',
                border: '1px solid #CED4DA',
                width: 'calc(100% - 25px)', // Adjust width to remove extra margin
                marginLeft: '15px',
                '&:hover': {
                    border: '1px solid #1976d2',
                }
            }}
        >
            <IconButton
                sx={{
                    marginRight: 2,
                    marginLeft: 0,
                    color: 'action.active',
                    padding: '3px',
                    '&:hover': {
                        backgroundColor: 'transparent',
                    }
                }}
                aria-label="drag"
                size="small"
            >
                <DragIndicatorIcon sx={{ fontSize: '1rem' }} />
            </IconButton>
            {children}
        </Box>
    );
});

export default withDrag(DraggablePreviewWrapper, 'field');
